import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import RegistrationPage from "./pages/RegistrationPage";
import IQTestPage from "./pages/IQTestPage";
import TypingTestPage from "./pages/TypingTestPage";
import ResultsPage from "./pages/ResultsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import "@/App.css";

function App() {
  return (
    <div className="App min-h-screen bg-[#F8F9FA]">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RegistrationPage />} />
          <Route path="/iq-test/:participantId" element={<IQTestPage />} />
          <Route path="/typing-test/:participantId" element={<TypingTestPage />} />
          <Route path="/results/:participantId" element={<ResultsPage />} />
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
